module.exports = __webpack_public_path__ + "media/common/icon-weather-cloudy-nighttime-a88f2b9d.svg";